import { Button } from "@/design-system/components/Button/Button";
import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";

const DEFAULT_DESCRIPTION = "Your progress will be lost if you leave now.";

interface CloseConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
  open: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
}

export function CloseConfirmation({
  onCancel,
  onConfirm,
  open,
  title = "Are you sure you want to leave?",
  description = DEFAULT_DESCRIPTION,
  confirmLabel = "Leave",
}: CloseConfirmationProps) {
  return (
    <Dialog
      title={title}
      description={description}
      open={open}
      onOpenChange={onCancel}
    >
      <DialogActionsWrapper>
        <Button onClick={onCancel} variant="ghost">
          Cancel
        </Button>
        <Button variant="destructive" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}
